import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { DxDataGridComponent } from 'devextreme-angular';
import { SelectionChangedEvent } from 'devextreme/ui/data_grid';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';

import { DcIcons } from '../../../../ui/app-dc.icons';
import { DcLoaders } from '../../../../ui/app-loaders';
import { ExpositionConsumerListEntity } from '../../../domain/exposition-consumer-list.entity';
import { ExpositionConsumerEntity } from '../../../domain/exposition-consumer.entity';

@Component({
	selector: 'app-exposition-consumer-list',
	templateUrl: './exposition-consumer-list.component.html',
	styleUrls: ['./exposition-consumer-list.component.scss'],
	inputs: ['consumerList'],
	exportAs: 'ConsumersGrid',
})
export class ExpositionConsumerListComponent extends DcBaseComponent {
	public selectionCount = 0;
	@ViewChild(DxDataGridComponent)
	private readonly grid!: DxDataGridComponent;
	@Output()
	public removeConsumers = new EventEmitter<Array<string>>();
	public vo$: Observable<{
		isFirstLoad: boolean;
		list: ExpositionConsumerListEntity;
	}>;

	protected readonly DcIcons = DcIcons;
	protected readonly DcLoaders = DcLoaders;

	protected readonly alert = alert;

	private readonly firstLoadSubject = new BehaviorSubject<boolean>(true);

	public constructor() {
		super();
		this.cmpId = 'exposition-consumers-list';
		this.dxLocalStorageKey = 'dx.grid.expositions:consumers-list';
		this.vo$ = combineAll({
			isFirstLoad: this.firstLoadSubject,
			list: this.toObservable<ExpositionConsumerListEntity>('consumerList'),
		});
	}

	public removeConsumer(key: number): void {
		this.removeConsumers.emit([`${key}`]);
	}

	public onSelectionChange($event: SelectionChangedEvent): void {
		this.selectionCount = $event.currentSelectedRowKeys.length;
	}

	public async onGridContentReady(): Promise<void> {
		const firstLaod = await firstValueFrom(this.firstLoadSubject);

		if (firstLaod) {
			this.firstLoadSubject.next(false);
		}
	}

	public search(searchTerm: string): void {
		if (this.grid === null) {
			return;
		}
		this.grid.instance.searchByText(searchTerm.trim());
	}

	public getSelectedConsumers(): Promise<Array<ExpositionConsumerEntity>> {
		return this.grid.instance.getSelectedRowsData();
	}
}
